import React from "react";
import {
  AccessTime,
  InfoOutlined,
  LineWeight,
  LocalShippingOutlined,
  LocationOnOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { localizeDateTimeShort } from "utils/dateFormats";

import { useShipmentLoadingDetailContext } from "contexts/ShipmentLoadingDetailContext";

const ShipmentLoadingBasicDetail = () => {
  const { shipmentLoadingDetail, loadingShipmentLoading } =
    useShipmentLoadingDetailContext();

  return !loadingShipmentLoading ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Loading ID"
            subtitle={shipmentLoadingDetail?.loadingId}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Loading Location"
            subtitle={`lat: ${shipmentLoadingDetail?.loadingLocation?.lat},
           lon: ${shipmentLoadingDetail?.loadingLocation?.lon}`}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Loading Time"
            subtitle={localizeDateTimeShort(shipmentLoadingDetail?.loadingTime)}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <LineWeight color="primary" />}
            title="Total Shipment Weight"
            subtitle={
              shipmentLoadingDetail?.totalWeight
                ? `${shipmentLoadingDetail.totalWeight} kg`
                : "N/A"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Loaded Branch"
            subtitle={shipmentLoadingDetail?.loadedBranch?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Unloading Status"
            subtitle={shipmentLoadingDetail?.unloadingStatus}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Driver"
            subtitle={shipmentLoadingDetail?.driverId?.name}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Vehicle"
            subtitle={`${shipmentLoadingDetail?.vehicle_id?.vehicle_id}-${shipmentLoadingDetail?.vehicle_id?.registration_number}`}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Is Active ?"
          >
            <Status isActive={shipmentLoadingDetail?.isActive} />
          </InformationTile>
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Created At"
            subtitle={localizeDateTimeShort(shipmentLoadingDetail?.createdAt)}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created By"
            subtitle={shipmentLoadingDetail?.createdBy?.name || "N/A"}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default ShipmentLoadingBasicDetail;
